/* Le Prestige 24 — panier avancé (sans app) */
(function(){
  var cfg = window.LP_CART || {};
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var money = function(c){ return new Intl.NumberFormat('fr-FR',{style:'currency',currency:cur}).format(c/100); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var drawer = function(){ return document.querySelector('cart-drawer'); };
  var sections = function(){ var d=drawer(); return d && d.getSectionsToRender ? d.getSectionsToRender().map(function(s){return s.id;}) : ['cart-drawer','cart-icon-bubble']; };
  var render = function(state){ var d=drawer(); if(d && d.renderContents && state.sections){ d.renderContents(state); } else { location.reload(); } };

  function getCart(){ return fetch(root+'cart.js').then(function(r){return r.json();}); }

  function shippingBar(cart){
    var t = parseInt(cfg.threshold||0,10)*100; if(!t) return '';
    var left = t - cart.total_price, pct = Math.min(100, Math.round(cart.total_price/t*100));
    var msg = left>0 ? 'Plus que <strong>'+money(left)+'</strong> pour profiter de la livraison offerte' : '<strong>Félicitations !</strong> La livraison vous est offerte';
    return '<div class="lp-ship"><p>'+msg+'</p><div class="lp-ship__bar"><span style="width:'+pct+'%"></span></div></div>';
  }

  function recos(cart){
    var inCart = cart.items.map(function(i){return i.product_id;});
    var src = cart.items.length ? root+'recommendations/products.json?limit=8&intent=related&product_id='+cart.items[0].product_id : root+'collections/best-sellers/products.json?limit=8';
    return fetch(src).then(function(r){return r.json();}).then(function(j){
      var list = (j.products||[]).filter(function(p){ return inCart.indexOf(p.id)<0 && p.available!==false; });
      if(list.length<3){ return fetch(root+'collections/best-sellers/products.json?limit=8').then(function(r){return r.json();}).then(function(b){ (b.products||[]).forEach(function(p){ if(inCart.indexOf(p.id)<0 && !list.some(function(x){return x.id===p.id;})) list.push(p); }); return list; }); }
      return list;
    }).then(function(list){
      list = list.slice(0,3); if(!list.length) return '';
      return '<div class="lp-upsell"><p class="lp-upsell__title">Complétez votre rituel</p><div class="lp-upsell__list">'+list.map(function(p){
        var v = p.variants[0], img = (p.featured_image||(p.images&&p.images[0]&&p.images[0].src)||''); var price = typeof v.price==='string' && v.price.indexOf('.')>-1 ? Math.round(parseFloat(v.price)*100) : v.price;
        if(img && typeof img==='object') img = img.src||'';
        return '<div class="lp-upsell__item"><a href="'+(p.url||('/products/'+p.handle))+'" class="lp-upsell__img">'+(img?'<img src="'+img+(img.indexOf('?')>-1?'&':'?')+'width=160" alt="" loading="lazy">':'')+'</a><div class="lp-upsell__info"><a href="'+(p.url||('/products/'+p.handle))+'">'+p.title+'</a><span>'+money(price)+'</span></div><button type="button" class="lp-upsell__add" data-variant="'+v.id+'">Ajouter</button></div>';
      }).join('')+'</div></div>';
    }).catch(function(){ return ''; });
  }

  function promo(cart){
    var codes = (cart.discount_codes||[]);
    var applied = codes.filter(function(c){return c.applicable;}).map(function(c){return c.code;});
    var bad = codes.filter(function(c){return !c.applicable;}).map(function(c){return c.code;});
    return '<details class="lp-promo"'+(applied.length||bad.length?' open':'')+'><summary>Vous avez un code promo ?</summary>'+
      '<form class="lp-promo__form"><input type="text" name="lp-code" placeholder="Code promo" autocomplete="off" value=""><button type="submit">Appliquer</button></form>'+
      (applied.length?'<p class="lp-promo__ok">Code <strong>'+applied.join(', ')+'</strong> appliqué <button type="button" class="lp-promo__rm">Retirer</button></p>':'')+
      (bad.length?'<p class="lp-promo__err">Le code <strong>'+bad.join(', ')+'</strong> n’est pas valable pour ce panier.</p>':'')+'</details>';
  }

  function trust(noLink){
    var pay = document.getElementById('lp-pay-icons');
    return (noLink?'':'<a href="'+root+'cart" class="lp-viewcart">Voir mon panier</a>')+'<div class="lp-trust-cart"><ul><li>Paiement 100 % sécurisé</li><li>Livraison suivie</li><li>Service client réactif</li></ul>'+(pay?'<div class="lp-pay">'+pay.innerHTML+'</div>':'')+'</div>';
  }

  var busy = false;
  function enhance(){
    var d = drawer(); if(!d || busy) return;
    var inner = d.querySelector('.drawer__inner'); if(!inner || inner.querySelector('.lp-enh')) return;
    busy = true;
    getCart().then(function(cart){
      var mark = document.createElement('span'); mark.className='lp-enh'; mark.hidden=true; inner.appendChild(mark);
      var header = inner.querySelector('.drawer__header');
      if(header && cart.item_count){ header.insertAdjacentHTML('afterend', shippingBar(cart)); }
      var footer = inner.querySelector('.drawer__footer');
      if(footer){
        footer.insertAdjacentHTML('afterbegin', promo(cart));
        var ctas = footer.querySelector('.cart__ctas') || footer.querySelector('.cart__checkout-button'); if(ctas){ ctas.insertAdjacentHTML('afterend', trust()); }
      }
      if(cart.item_count){ return recos(cart).then(function(h){ var items = inner.querySelector('cart-drawer-items'); if(h && items){ var box = items.querySelector('.drawer__contents') || items; box.insertAdjacentHTML('beforeend', h); } }); }
    }).finally(function(){ busy=false; });
  }

  var onCartPage = function(){ return !!document.getElementById('main-cart-footer'); };
  var busyPage = false;
  function enhancePage(){
    var foot = document.getElementById('main-cart-footer'); if(!foot || busyPage || foot.querySelector('.lp-enh')) return;
    var ctas = foot.querySelector('.cart__ctas'); if(!ctas) return;
    busyPage = true;
    getCart().then(function(cart){
      var mark = document.createElement('span'); mark.className='lp-enh'; mark.hidden=true; foot.appendChild(mark);
      ctas.insertAdjacentHTML('beforebegin', '<div class="lp-promo-page">'+promo(cart).replace('<details class="lp-promo"','<details open class="lp-promo"')+'</div>');
      ctas.insertAdjacentHTML('afterend', trust(true));
    }).finally(function(){ busyPage=false; });
  }

  document.addEventListener('click', function(e){
    var add = e.target.closest('.lp-upsell__add');
    if(add){ e.preventDefault(); add.disabled=true; add.textContent='…';
      fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+add.dataset.variant,quantity:1}],sections:sections(),sections_url:location.pathname})})
        .then(function(r){return r.json();}).then(render).catch(function(){add.disabled=false;add.textContent='Ajouter';});
    }
    var rm = e.target.closest('.lp-promo__rm');
    if(rm){ e.preventDefault(); applyCode(''); }
  });
  document.addEventListener('submit', function(e){
    var f = e.target.closest('.lp-promo__form'); if(!f) return; e.preventDefault();
    var code = (f.querySelector('input').value||'').trim(); if(code) applyCode(code);
  });
  function applyCode(code){
    fetch(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:code,sections:sections(),sections_url:location.pathname})})
      .then(function(r){return r.json();}).then(function(state){ var d=drawer(); if(onCartPage() && !(d && d.classList.contains('active'))){ location.reload(); } else { render(state); } });
  }

  new MutationObserver(function(){ enhance(); enhancePage(); }).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('DOMContentLoaded', function(){ enhance(); enhancePage(); }); enhance(); enhancePage();
})();
